export default __webpack_public_path__ + "static/media/public-share.f895f462.svg";